module.exports = __webpack_public_path__ + "static/media/sneha_content.2b1736f6.jpg";